import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-agent-details',
  templateUrl: './agent-details.component.html',
  styleUrls: ['./agent-details.component.scss']
})
export class AgentDetailsComponent implements OnInit {

  constructor(public globals: Globals) { }

  ngOnInit() {
  }

  setValue(value) {
    this.globals.setValue(value);
  }

}
